import React, { useEffect, useState } from "react";
import Button from "../../../atoms/Button";
import { useUserList } from "../../../../api/admin/user/hooks";
import { useAdminReviewDetail, useCreateReview, useDeleteReview, useModifyReview } from "../../../../api/admin/review/hooks";
import { useLocation, useNavigate } from "react-router-dom";
import ReviewAdminForm from "../../../organisms/ReviewAdminForm";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { showConfirm } from "../../../../reducer/confirmSlice";
import IconCircle from "../../../atoms/IconCircle";
import { showAlert } from "../../../../reducer/alertSlice";

/**
 * 리뷰 정보 수정
 * - 관리자용 화면
 */

const ReviewModify = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const locationPath = useLocation().pathname;
    const locationIdx = locationPath.split("/").pop();

    const [reviewData, setReviewData] = useState({});

    const { data: userList, isLoading: userListIsLoading, refetch: userListrefetch } = useUserList();
    const { data: reviewDetail, isLoading: reviewDetailIsLoading } = useAdminReviewDetail(locationIdx);
    const { mutate, isSuccess, error } = useModifyReview(reviewData);
    const { mutate: deleteReview, isLoading: isDeleteReviewLoading } = useDeleteReview();

    useEffect(() => {
        if (reviewDetail) {
            console.log("@reviewDetail.data", reviewDetail.data);
            let tmp = { ...reviewDetail.data };
            tmp["idx"] = locationIdx;
            setReviewData(tmp);
        }
    }, [reviewDetail]);

    useEffect(() => {
        if (isSuccess) {
            goToList();
        }
    }, [navigate, isSuccess]);

    useEffect(() => {
        if (error) {
            let msgText = "오류가 발생했습니다:\n" + error
            switch (error?.response?.data?.code) {
                case -2:
                case -12:
                    msgText = "필수 값들을 모두 입력해주세요."
                    break
                case -14:
                    msgText = "이미 존재하는 리뷰 제목입니다."
                    break
            }
            dispatch(
                showAlert({
                    msg: msgText,
                })
            );
        }
    }, [navigate, error]);

    const submitEvent = () => {
        if (reviewData.status === "2") {
            dispatch(showAlert({
                msg: "진행중인 리뷰는 수정할 수 없습니다."
            }))
            return
        }
        // 주관식일 땐 options 값 빼고 제출
        const payload = {
            ...reviewData,
            questions: reviewData.questions.map(q => {
                if (q.type === "0") return q
                const { options, ...rest } = q
                return rest
            })
        }
        mutate(payload)
        console.log("@submit reviewData", payload);
    };

    const reviewDeleteHandler = () => {
        if (reviewData.status === "2") {
            dispatch(showAlert({
                msg: "진행중인 리뷰는 삭제할 수 없습니다."
            }))
        } else {
            dispatch(showConfirm({
                msg: "리뷰를 삭제할까요?",
                func: () => {
                    deleteReview(locationIdx, {
                        onSuccess: () => {
                            goToList();
                        },
                    });
                }
            }))
        }
    };

    function goToList() {
        //@ 보통 전에 보고있던 목록으로 잘 되돌아가긴 하지만, url에 파라미터를 직접 입력하여 들어왔다든지의 경우로 진입하면 목록으로 되돌아가지 않음
        navigate(-1);
    }

    return (
        <>
            <Container>
                <div className="inner">
                    <Header>
                        <h2>리뷰 수정</h2>
                        <IconCircle className="bi-trash3" onClick={() => reviewDeleteHandler()} alt="리뷰 삭제" />
                    </Header>

                    <ReviewAdminForm stateValue={[reviewData, setReviewData]} userListData={userList ? userList.data : [{}]} />

                    <Button type="deep" className="submitButton" onClick={submitEvent}>
                        리뷰 수정
                    </Button>
                </div>
            </Container>
        </>
    );
};

const Container = styled.div`
    display: flex;

    .inner {
        display: flex;
        flex-direction: column;
        width: 800px;
        gap: 30px;
    }

    .submitButton {
        height: 4rem;
    }
`

const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`

export default ReviewModify;